/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Task_Operations_AreaInputs */

const en_home_task_operations_area = /** @type {(inputs: Home_Task_Operations_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations`)
};

const lv_home_task_operations_area = /** @type {(inputs: Home_Task_Operations_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikdienas darbs`)
};

/**
* | output |
* | --- |
* | "Operations" |
*
* @param {Home_Task_Operations_AreaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_task_operations_area = /** @type {((inputs?: Home_Task_Operations_AreaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Task_Operations_AreaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_task_operations_area(inputs)
	return en_home_task_operations_area(inputs)
});